var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading-page',{attrs:{"title":"Saindo de sua conta..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }